export default __webpack_public_path__ + "static/media/down_arrow.09ffb8e9.svg";